import React from 'react';
import { IconProps } from '.';

const SvgNumOneFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path fill={secondaryColor} d='M13.68 7.017h-1.85L9.5 8.502v1.731l2.162-1.354h.051v7.565h1.967V7.017Z' />
    </svg>
  );
};

export default SvgNumOneFill;
